module.exports = __webpack_public_path__ + "c63c4f2f552bd3878a6beee8a56d0acd.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-768.webp.png
// module id = 219
// module chunks = 0